import "core-js/modules/es.array.iterator.js";
import React from 'react';
import clsx from 'clsx';
import { getArchiveIcon } from '@isyc-react/archives/view/tools';
import { RippleButton } from '@isyc-react/form/modules/base';
import { useTrail, a } from '@isyc-react/animation/lib';
import { DropPreview } from "../../../drop-preview";
import { useTranslation } from 'react-i18next';
import { nsformfile } from "../../../../../i18n/namespaces";
import '@isyc-react/design/main';
export const DropSingleAcceptedView = props => {
  const {
    accepted,
    open,
    remove,
    disabled
  } = props;
  const {
    t
  } = useTranslation(nsformfile.common);
  const [preview, setPreview] = React.useState(false);
  const name = React.useMemo(() => {
    var _accepted$api;
    return accepted.file ? accepted.file.name : (_accepted$api = accepted.api) === null || _accepted$api === void 0 ? void 0 : _accepted$api.name;
  }, [accepted]);
  const classes = getArchiveIcon(name);
  const trail = useTrail(2, {
    config: {
      mass: 1,
      tension: 100,
      friction: 10
    },
    from: {
      opacity: 0,
      transform: 'translate3d(0px,50px,0)'
    },
    to: {
      opacity: 1,
      transform: 'translate3d(0,0,0)'
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(a.div, {
    className: "col d-flex align-items-center justify-content-center",
    style: trail[0]
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx(classes.icon, 'font-size-22 me-2')
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-nowrap"
  }, name)))), /*#__PURE__*/React.createElement(a.div, {
    className: "col d-flex my-2 justify-content-center",
    style: trail[1]
  }, /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-outline-primary me-2",
    onClick: () => {
      setPreview(true);
    }
  }, t('drop.zone.accepted.view')), !disabled && /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-outline-primary me-2",
    onClick: open
  }, t('drop.zone.accepted.change')), !disabled && !accepted.api && /*#__PURE__*/React.createElement(RippleButton, {
    type: "button",
    className: "btn btn-outline-primary",
    onClick: remove
  }, t('drop.zone.accepted.remove'))), /*#__PURE__*/React.createElement(DropPreview, {
    value: accepted,
    show: preview,
    onChange: setPreview
  })));
};